module.exports = {
    language: {
        title: '选择您的语言<br/>(Choose your language)',
        lang:'中文简体'
    },
    start:{
        startText:'狮子饿了!<br/>一起喂养吧。',
        startButton:'开始喂养',
        openTip:'为了更好的游戏体验，请到设置->Safari浏览器->隐私权和安全性，开启【动作与方向访问】。',
        toBrowser:'请点击右上方的按钮，在浏览器开启Wenno虚拟现实游戏，体验喂食动物的快乐吧！',
        example:'例如：'
    },
    game:{
        resultText:'恭喜你成为',
        saveBtn:'截图保存',
        press:'长按图片可以直接传送给朋友，或先储存图片到手机再分享朋友圈。',
        trainer:'驯兽师'
    },
    animals:{
        lion:'狮子',
    },
    loading:{
        tipsText0:'用手指滑动屏幕，点击动物喜欢吃的食物，它就会越来越喜欢你。',
        tipsText1:'举起手机，左右移动，点击动物喜欢吃的食物，它就会越来越喜欢你。',
        tipsTitle:'玩法提示',
        load:'加载中'
    },
    success:{
        successText:'成功喂养',
        text:'恭喜你成为',
        otherText:'挑战其他动物',
        continueTitle:'继续游戏',
        playAgain:'再玩一次',
        understandTitle:'了解更多',
        downloadTitle:'下载',
        trainer:'驯兽师',
        apple:'苹果商店',
        google:'谷歌商店',
        xiaomi:'小米商店',
        huawei:'华为商店'
    }

}


// WEBPACK FOOTER //
// ./src/assets/common/lang/zh.js